var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChangeLanguage(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "#D66700"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.87 23.07L18.33 20.56L18.36 20.53C20.0547 18.6475 21.3205 16.4195 22.07 14H25V12H18V10H16V12H9V14H20.17C19.5 15.92 18.44 17.75 17 19.35C16.07 18.32 15.3 17.19 14.69 16H12.69C13.42 17.63 14.42 19.17 15.67 20.56L10.58 25.58L12 27L17 22L20.11 25.11L20.87 23.07ZM26.5 18H24.5L20 30H22L23.12 27H27.87L29 30H31L26.5 18ZM23.88 25L25.5 20.67L27.12 25H23.88Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChangeLanguage);
export default __webpack_public_path__ + "static/media/Change-Language.87a9fd472e083bdade04b2f183cbafd4.svg";
export { ForwardRef as ReactComponent };